import { useHeadlinePrices } from '../../../../contexts/fill/use-fill-prescription';
import { useProgramTerms } from '../../../../hooks/use-program-terms';
import { hasIncentiveSavings } from '../../../../util/offers/has-incentive-savings';
import {
    isIncentiveOffer,
    isIncentivePrice,
} from '../../../../util/offers/is-incentive-offer';
import { usePriceQualifier } from '../../fill/common/use-price-qualifier';
import { SelfPayPricingContent } from '../../fill/self-pay/SelfPayPricingContent';

import type { PricingComponentProps } from './pricing-types';

export const SelfPayPricing = ({
    medication,
    price,
    priceType,
    selectedOffer,
}: PricingComponentProps) => {
    const terms = useProgramTerms(medication, 'self-pay');

    const headlinePrices = useHeadlinePrices(medication);
    const listPrice = headlinePrices.find((hp) => hp.type === 'Cash');
    const savings =
        price && listPrice && isIncentivePrice(priceType)
            ? listPrice.value - price
            : null;

    const priceQualifier = usePriceQualifier({
        medication,
        patientPay: price,
        priceType,
    });

    const hasIncentiveProgram = isIncentiveOffer(selectedOffer);
    const termsDisclaimer = isIncentiveOffer(selectedOffer)
        ? (terms?.incentiveProgram?.disclaimer ?? '')
        : '';

    // hasIncentiveProgram only tells us the selected offer is Incentive-typed —
    // some doses carry one with no real discount (Incentive === Cash) purely to
    // trigger the purchase-certification disclaimer above. Only a genuine discount
    // (see hasIncentiveSavings) should route to the incentive terms/link.
    const hasJourneyProgram =
        hasIncentiveProgram && hasIncentiveSavings(selectedOffer, savings);

    return (
        <SelfPayPricingContent
            hasIncentiveProgram={hasJourneyProgram}
            medication={medication}
            offer={selectedOffer}
            patientPay={price}
            priceQualifier={priceQualifier}
            priceType={priceType}
            savings={savings}
            termsDisclaimer={termsDisclaimer}
        />
    );
};
